//#region import
import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

// pages
import Home from '_scenes/website/home/index.js';
import Register from '_scenes/portal/register';
import Download from '_scenes/website/download';
import Business from '_scenes/website/business';
import AboutUs from '_scenes/website/about-us';
import Contact from '_scenes/website/contact';
import DeleteAccount from '_scenes/website/delete-account';
import Testing from '_scenes/website/testing';
import Privacy from '_scenes/website/privacy-policy';
import ConfirmBooking from '_scenes/website/confirm-booking';
import CookiePolicy from '_scenes/website/cookies';
import PassengerSurvey from '_scenes/website/passenger-survey';
import ReviewBooking from '_scenes/website/review-booking'
import RequestDemo from '_scenes/website/request-demo';

//#region user marketplace
import RetailerProductScreen from '_scenes/portal/marketplace/user-marketplace/retailer-products.js';
import CheckoutPage from '../scenes/portal/marketplace/user-marketplace/checkout-page';
import OrderComplete from '../scenes/portal/marketplace/user-marketplace/order-complete';
import GenerateQRCode from '../scenes/portal/utils/generate-qr-code';
import TermsAndConditions from '_scenes/portal/marketplace/user-marketplace/terms-and-conditions';
import AirportSurvey from '_scenes/website/airport-survey';
import SurveyPreview from '_scenes/website/survey-preview';
//#endregion

// analytics
import GTM from '_components/atoms/gtm';
import CookieConsent from '_components/atoms/cookie-consent';


const AuthRouter = () => {
  const [consentGiven, setConsentGiven] = useState(false);

  const handleConsentChange = (choice) => {
    setConsentGiven(choice === 'accepted');
  };

  return (
    <Router>
      <GTM consentGiven={consentGiven} />
      <CookieConsent onConsentChange={handleConsentChange} />
      <Switch>

        <Route path="/login">
          <Register login={true} />
        </Route>

        <Route path="/download">
          <Download />
        </Route>

        <Route path="/business">
          <Business />
        </Route>

        <Route path="/about-us">
          <AboutUs />
        </Route>

        <Route path="/contact">
          <Contact />
        </Route>

        <Route path="/delete-account">
          <DeleteAccount />
        </Route>

        {/* NO LONGER USED */}
        {/* <Route path="/testing">
          <Testing />
        </Route> */}

        {/* This route for review email, instead of app screen, temp solution */}
        <Route path="/review/:bookingId">
          <ReviewBooking />
        </Route>

        <Route path="/confirm-booking/:id/:airport">
          <ConfirmBooking />
        </Route>

        <Route path="/survey/:bookingId/:taskId/:surveyId/:iata/en">
          <PassengerSurvey />
        </Route>

        <Route path="/caa-survey/:surveyId/:airport">
          <AirportSurvey />
        </Route>

        <Route path="/survey-preview/:iata/:surveyId">
          <SurveyPreview />
        </Route>



        <Route path="/privacy">
          <Privacy />
        </Route>

        <Route path="/request-demo">
          <RequestDemo fromPage={'app'} />
        </Route>

        <Route path="/cookies">
          <CookiePolicy />
        </Route>

        {/* user marketplace */}
        <Route path="/retailer-products/:retailerId">
          <RetailerProductScreen />
        </Route>

        <Route path="/terms-and-conditions">
          <TermsAndConditions />
        </Route>

        <Route path="/checkout">
          <CheckoutPage />
        </Route>

        <Route path="/order-complete">
          <OrderComplete />
        </Route>

        <Route path="/qr-code-generator">
          <GenerateQRCode />
        </Route>

        {/* home */}
        <Route path="/">
          <Home />
        </Route>

      </Switch>
    </Router>
  );
};

export default AuthRouter;
